import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex items-center justify-between px-6 py-4" style={{ maxWidth: 1280 }}>
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
            91
          </span>
          <span className={`font-heading text-xl font-semibold ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'}`}>
            {siteInfo.name}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/' ? 'text-primary-500' : (isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50')
            }`}
          >
            首页
          </Link>
          <Link
            to="/category/resource-navigation"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname.startsWith('/category') ? 'text-primary-500' : (isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50')
            }`}
          >
            资源分类
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about' ? 'text-primary-500' : (isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50')
            }`}
          >
            关于我们
          </Link>
          <a
            href="#"
            className={`ml-2 px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
              isScrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30'
            }`}
          >
            注册 / 登录
          </a>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
            isScrolled ? 'text-foreground-900' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-6 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-700 py-2">首页</Link>
          <Link to="/category/resource-navigation" className="text-sm font-medium text-foreground-700 py-2">资源分类</Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 py-2">关于我们</Link>
          <a href="#" className="text-sm font-medium text-primary-500 py-2">注册 / 登录</a>
        </div>
      )}
    </header>
  );
}